<ng-icon [name]="ICONS_NAME_MAP[name()]"
         [size]="ICON_SIZE_MAP[size()]"
         [strokeWidth]="strokeWidth()"/>
